exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-caa0978a]{background-image:linear-gradient(to right, #ff8214, #ffa014)}.header__body[data-v-caa0978a]{position:relative;display:flex;width:1140px;height:52px;align-items:center;justify-content:space-between;padding:0 10px 4px;margin:0 auto}.header__logo[data-v-caa0978a]{flex-shrink:0;margin-top:8px}.header__links[data-v-caa0978a]{flex-shrink:0}", ""]);

// exports
